import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductRetirementAges = createAction('[StaticData] Load ProductRetirementAges');

export const loadProductRetirementAgesSuccess = createAction(
  '[StaticData] Load ProductRetirementAges Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductRetirementAgesFailure = createAction('[StaticData] Load ProductRetirementAges Failure', props<{ error: any }>());
